<template>
  <div class="container sv059">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>会員さま専用サイト・専用アプリについて</HeadingOne>

    <section>
      <div class="main-box">
        <div class="txt-box">
          <p class="txt01">
            au PAY
            スマートローンでは、会員のみなさまに安心してご利用いただくための便利な会員さま専用サイトをご用意しております。<br />
            パソコン・スマートフォンでどなたでもすぐにご利用いただけます。<br />
            さらに、専用アプリをインストールするとセブン銀行スマホATMでいつでもお借り入れ、ご返済が可能です。
          </p>
        </div>
        <div class="img-box _mb-sm-80">
          <img
            src="@/assets/images/sv/sv059/phone.png"
            class="img-fluid"
            alt=""
          />
        </div>
      </div>
    </section>

    <!--<p class="txt01">-->
    <!--パソコン・スマートフォンでご利用可能な会員サービスに<br>-->
    <!--ログインしてどなたでもすぐにご利用いただけます。<br>-->
    <!--さらに、アプリならセブン銀行スマホATMで<br>-->
    <!--いつでもお借り入れ、ご返済が可能です-->
    <!--</p>-->

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal" router-name="ce001"
        >会員さま専用サイトトップへ</BtnMain
      >
    </BtngroupSingle>

    <HeadingTwo>au PAY スマートローンアプリについて</HeadingTwo>

    <div class="au-wallet-box _mb-sm-60 _mb-md-120">
      <div class="card _ml-md-40">
        <div class="card-img">
          <img
            src="@/assets/images/sv/sv059/seven.svg"
            class="icon"
            alt="セブン銀行"
          />
        </div>
        <div class="card-body">
          <h4 class="card-title">
            au PAY
            スマートローンアプリをインストールすると、原則24時間365日全国のセブン銀行ATMでお借り入れ、ご返済が行えます。
          </h4>
          <ListGroup class="-note">
            <ListItem class="-note"
              >ご利用には、 au PAY
              スマートローンアプリが必要となります。</ListItem
            >
            <ListItem class="-note"
              >システムメンテナンスなどでご利用いただけない場合がございます。</ListItem
            >
            <ListItem class="-note"
              >ＡＴＭ手数料として、お借り入れ、ご返済の取引金額１万円以下の場合は110円（税込）、１万円を超える場合は220円（税込）をご負担いただきます。</ListItem
            >
            <ListItem class="-note"
              >お借り入れ時に発生するＡＴＭ手数料は、次回のご返済時にご精算いただきます。</ListItem
            >
            <ListItem class="-note"
              >ご返済時に発生するＡＴＭ手数料は、ご返済とあわせてご精算いただきます。</ListItem
            >
          </ListGroup>
        </div>
      </div>
    </div>

    <template v-if="!isWebView()">
      <section class="_mb-md-120 _mb-sm-60">
        <HeadingTwo id="section_01" name="section_01"
          >アプリダウンロード</HeadingTwo
        >
        <AppDownlord></AppDownlord>
      </section>
    </template>

    <HeadingTwo>会員さま専用サイトでご利用可能な情報やお手続き一覧</HeadingTwo>

    <p class="_mb-md-50 _mb-sm-40">以下情報やお手続きがご利用になれます。</p>

    <section class="_mb-md-60 _mb-sm-40">
      <TableBox>
        <TableBody>
          <TableRow>
            <TableHeader>ご利用状況</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">ご利用可能額</ListItem>
                <ListItem class="-normal">ご利用残高</ListItem>
                <ListItem class="-normal">ご利用限度額</ListItem>
                <ListItem class="-normal">次回ご返済日</ListItem>
                <ListItem class="-normal">次回ご返済金額</ListItem>
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>お借り入れ</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">au PAY 残高にチャージ</ListItem>
              </ListGroup>
              <BtnText router-name="sv024" class="-next"
                >詳しくはこちら</BtnText
              >
              <ListGroup class="-normal _mt-30">
                <ListItem class="-normal">ご登録口座へのお振込み</ListItem>
              </ListGroup>
              <BtnText router-name="sv023" class="-next"
                >詳しくはこちら</BtnText
              >
              <ListGroup class="-normal _mt-30">
                <ListItem class="-normal">セブン銀行スマホATM</ListItem>
              </ListGroup>
              <ListGroup class="-note">
                <ListItem class="-note"
                  >セブン銀行スマホATMはau PAY
                  スマートローンアプリ専用のサービスになります。</ListItem
                >
              </ListGroup>
              <BtnText router-name="sv025" class="-next"
                >詳しくはこちら</BtnText
              >
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>ご返済</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">ご登録口座からのお引落し</ListItem>
              </ListGroup>
              <BtnText router-name="sv026" class="-next"
                >詳しくはこちら</BtnText
              >
              <ListGroup class="-normal _mt-30">
                <ListItem class="-normal">セブン銀行スマホATM</ListItem>
              </ListGroup>
              <ListGroup class="-note">
                <ListItem class="-note"
                  >セブン銀行スマホATMはau PAY
                  スマートローンアプリ専用のサービスになります。</ListItem
                >
              </ListGroup>
              <BtnText router-name="sv029" class="-next"
                >詳しくはこちら</BtnText
              >
              <ListGroup class="-normal _mt-30">
                <ListItem class="-normal">指定口座へのお振込み</ListItem>
              </ListGroup>
              <BtnText router-name="sv027" class="-next"
                >詳しくはこちら</BtnText
              >
              <ListGroup class="-normal _mt-30">
                <ListItem class="-normal">ご返済シミュレーション</ListItem>
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>お客さま情報</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">お客さま情報の確認・変更</ListItem>
                <ListItem class="-normal">口座情報の登録・変更</ListItem>
                <ListItem class="-normal">暗証番号再設定</ListItem>
                <ListItem class="-normal"
                  >メールアドレス・お知らせ通知設定の変更</ListItem
                >
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>ご契約・お取引情報</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">ご契約内容のご確認</ListItem>
                <ListItem class="-normal">お取引履歴のご確認</ListItem>
                <ListItem class="-normal">ご契約締結書面一覧のご確認</ListItem>
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>お知らせ</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">緊急のお知らせ</ListItem>
                <ListItem class="-normal">重要なお知らせ</ListItem>
                <ListItem class="-normal">メッセージ</ListItem>
                <ListItem class="-normal">トピックス</ListItem>
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>キャンペーン</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal">各種キャンペーンのご案内</ListItem>
              </ListGroup>
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>
    </section>
    <CvBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtnText from "@/components/button/BtnText";
import AppDownlord from "@/components/others/AppDownlord";
import CvBox from "@/components/box/CvBox";
import { isWebView } from "@/utils/UserAgent";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv059",
  components: {
    CvBox,
    AppDownlord,
    BtnText,
    ListItem,
    ListGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtngroupSingle,
    BtnMain,
    HeadingOne,
    HeadingTwo,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title:
        "会員さま専用サイト・専用アプリについて｜お申し込み条件・お手続きの流れ",
      description:
        "会員さま専用サイト、セブン銀行スマホATMが利用できる専用スマートフォンアプリについて分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員サイト,スマートフォンアプリ",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お申し込み条件・お手続きの流れ",
          routerName: "sv045",
        },
        {
          text: "会員さま専用サイト・専用アプリについて",
          active: true,
        },
      ],
    };
  },
  mounted() {
    setTimeout(this.scrolleToHash, 300);
  },
  methods: {
    scrolleToHash() {
      if (this.$route.hash.match(/^#/)) {
        let id = this.$route.hash.replace(/^#/, "");
        let offset = this.isWebView()
          ? -10
          : -(document.getElementById(id).clientHeight * 3);
        this.$scrollTo(this.$route.hash, 400, {
          easing: "ease",
          offset: offset,
        });
      }
    },
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.sv059 {
  .main-box {
    margin-bottom: -34px;
    @include mq-up(md) {
      display: flex;
      align-items: center;
    }
    > .txt-box {
      @include mq-up(md) {
        width: 70%;
      }
      .txt01 {
        font-size: 16px;
        line-height: 24px;
        @include mq-down(md) {
          margin-bottom: 40px;
        }
        @include mq-up(md) {
          font-size: 18px;
          line-height: 42px;
        }
      }
    }
    > .img-box {
      z-index: 2;
      position: relative;
      @include mq-up(md) {
        width: 30%;
      }
      @include mq-down(md) {
        padding-left: 10%;
        padding-right: 10%;
      }
    }
  }

  .au-wallet-box {
    > .card {
      @include mq-up(md) {
        display: flex;
      }
      img {
        margin-bottom: 20px;
        @include mq-up(md) {
          margin-bottom: 30px;
        }
      }
      > .card-img {
        width: 50%;
        @include mq-down(md) {
          margin: 0 auto;
        }
        @include mq-up(md) {
          width: 18%;
        }
      }
      > .card-body {
        @include mq-up(md) {
          width: 77%;
          padding-top: 20px;
          margin-left: 5%;
        }
        > .card-title {
          font-size: 18px;
          line-height: 26px;
          color: $primary;
          font-weight: bold;
          margin-bottom: 20px;
          @include mq-down(md) {
            text-align: center;
          }
          @include mq-up(md) {
            font-size: 24px;
            line-height: 36px;
          }
        }
        > .card-text {
          padding-left: 10px;
          padding-right: 10px;
        }
        > .card-bg {
          background-color: #fff;
          > .txt01 {
            padding-top: 10px;
            padding-bottom: 10px;
            text-align: center;
            span {
              color: $primary;
              font-size: 20px;
              line-height: 24px;
            }
          }
        }
      }
      .icon-box {
        > .icon {
          width: 8px;
          margin-bottom: 4px;
        }
      }
    }
  }

  .card-body {
    padding: 0;
    h2 {
      font-size: 32px;
      line-height: 40px;
    }
  }
  > .txt01 {
    font-size: 18px;
    line-height: 140%;
    @include mq-up(md) {
      font-size: 28px;
      line-height: 200%;
    }
  }
  .app-box {
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    > .txt-box {
      @include mq-up(md) {
        width: 70%;
      }
      .txt02 {
        font-size: 22px;
        line-height: 130%;
        color: $orange;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 32px;
        }
      }
    }
    > .img-box {
      @include mq-up(md) {
        width: 30%;
      }
      .logo {
        display: flex;
        max-width: 140px;
        width: 100%;
        display: block;
        margin: 0 auto;
        @include mq-up(md) {
          max-width: 180px;
        }
      }
    }
  }
}
</style>
